var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("div", [
        _c("p", {
          staticClass: "icon-jujue closeBtn",
          on: { click: _vm.routerBack },
        }),
      ]),
      _c(
        "div",
        { staticClass: "content_box" },
        [
          _c(
            "el-row",
            { staticStyle: { margin: "5px 0" } },
            [
              _vm.detailForm.status !== "SUBMITTED" &&
              (_vm.ms_roles.indexOf("QSPI_RMC_CHICK_BUYER_SUPP") !== -1 ||
                _vm.ms_roles.indexOf("QSPI_RMC_PORK_BUYER_SUPP") !== -1) &&
              !_vm.isDisabled
                ? _c(
                    "el-button",
                    {
                      directives: [
                        {
                          name: "acl",
                          rawName: "v-acl",
                          value: _vm.RMC_PROT_PCQTY_SUBMIT,
                          expression: "RMC_PROT_PCQTY_SUBMIT",
                        },
                      ],
                      staticClass: "btn",
                      attrs: { size: "mini", type: "primary" },
                      on: {
                        click: function ($event) {
                          return _vm.onSubmit("SAVE", "保存成功")
                        },
                      },
                    },
                    [_vm._v("保存")]
                  )
                : _vm._e(),
              (_vm.ms_roles.indexOf("QSPI_RMC_CHICK_BUYER_SUPP") !== -1 ||
                _vm.ms_roles.indexOf("QSPI_RMC_PORK_BUYER_SUPP") !== -1) &&
              !_vm.isDisabled
                ? _c(
                    "el-button",
                    {
                      directives: [
                        {
                          name: "acl",
                          rawName: "v-acl",
                          value: _vm.RMC_PROT_PCQTY_SUBMIT,
                          expression: "RMC_PROT_PCQTY_SUBMIT",
                        },
                      ],
                      staticClass: "btn",
                      attrs: { size: "mini", type: "primary" },
                      on: {
                        click: function ($event) {
                          return _vm.onSubmit("SUBMITTED", "提交成功")
                        },
                      },
                    },
                    [_vm._v("提交")]
                  )
                : _vm._e(),
            ],
            1
          ),
          _c(
            "el-form",
            {
              ref: "detailForm",
              attrs: {
                model: _vm.detailForm,
                rules: _vm.rules,
                "label-width": "120px",
              },
            },
            [
              _c("div", { staticClass: "within_box" }, [
                _c("div", { staticClass: "title_box" }, [
                  _c("p", { staticClass: "line" }),
                  _c("p", { staticClass: "title" }, [_vm._v("基本信息")]),
                ]),
                _c(
                  "div",
                  { staticClass: "form_box" },
                  [
                    _c(
                      "el-row",
                      { attrs: { gutter: 20 } },
                      [
                        _c(
                          "el-col",
                          { attrs: { span: 6 } },
                          [
                            _c(
                              "el-form-item",
                              {
                                attrs: { label: "单据号", prop: "documentNo" },
                              },
                              [
                                _c("el-input", {
                                  attrs: {
                                    disabled: "",
                                    placeholder: "请输入内容",
                                  },
                                  model: {
                                    value: _vm.detailForm.documentNo,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.detailForm,
                                        "documentNo",
                                        $$v
                                      )
                                    },
                                    expression: "detailForm.documentNo",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _c(
                          "el-col",
                          { attrs: { span: 6 } },
                          [
                            _c(
                              "el-form-item",
                              {
                                staticClass: "is-required",
                                attrs: {
                                  label: "报告期限",
                                  prop: "month",
                                  rules: _vm.rules.month,
                                },
                              },
                              [
                                _c("el-date-picker", {
                                  staticStyle: { width: "100%" },
                                  attrs: {
                                    disabled: _vm.isDisabled,
                                    type: "month",
                                    "value-format": "yyyy-MM",
                                    placeholder: "请选择",
                                  },
                                  model: {
                                    value: _vm.detailForm.month,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.detailForm, "month", $$v)
                                    },
                                    expression: "detailForm.month",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _c(
                          "el-col",
                          { attrs: { span: 6 } },
                          [
                            _c(
                              "el-form-item",
                              {
                                staticClass: "is-required",
                                attrs: {
                                  label: "Category3",
                                  prop: "category3Code",
                                  rules: _vm.rules.category3Code,
                                },
                              },
                              [
                                _c(
                                  "el-select",
                                  {
                                    staticStyle: { width: "100%" },
                                    attrs: {
                                      disabled:
                                        _vm.isDisabled ||
                                        _vm.ttRmcProteinPurchaseId ||
                                        _vm.isCategory ||
                                        (_vm.detailForm.category3Code &&
                                          this.filteredTableData.length > 0),
                                    },
                                    model: {
                                      value: _vm.detailForm.category3Code,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.detailForm,
                                          "category3Code",
                                          $$v
                                        )
                                      },
                                      expression: "detailForm.category3Code",
                                    },
                                  },
                                  _vm._l(
                                    _vm.category3CodeOptions,
                                    function (item, index) {
                                      return _c("el-option", {
                                        key: index,
                                        attrs: {
                                          label: item.object,
                                          value: item.key,
                                        },
                                      })
                                    }
                                  ),
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _c(
                          "el-col",
                          { attrs: { span: 6 } },
                          [
                            _c(
                              "el-form-item",
                              {
                                attrs: { label: "供应商", prop: "sponsorName" },
                              },
                              [
                                _c("el-input", {
                                  staticStyle: { width: "100%" },
                                  attrs: { disabled: "" },
                                  model: {
                                    value: _vm.detailForm.sponsorName,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.detailForm,
                                        "sponsorName",
                                        $$v
                                      )
                                    },
                                    expression: "detailForm.sponsorName",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "el-row",
                      { attrs: { gutter: 20 } },
                      [
                        _c(
                          "el-col",
                          { attrs: { span: 6 } },
                          [
                            _c(
                              "el-form-item",
                              { attrs: { label: "状态", prop: "status" } },
                              [
                                _c("ic-select", {
                                  staticStyle: { width: "100%" },
                                  attrs: {
                                    table: "TT_RMC_PROTEIN_PURCHASE",
                                    field: "STATUS",
                                    disabled: "",
                                    placeholder: "请选择",
                                  },
                                  model: {
                                    value: _vm.detailForm.status,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.detailForm, "status", $$v)
                                    },
                                    expression: "detailForm.status",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _vm.ttRmcProteinPurchaseId &&
                    _vm.detailForm.status !== "DRAFT"
                      ? _c(
                          "el-row",
                          { attrs: { gutter: 20 } },
                          [
                            _c(
                              "el-col",
                              { attrs: { span: 24 } },
                              [
                                _c(
                                  "el-form-item",
                                  {
                                    attrs: {
                                      label: "上次修改原因",
                                      prop: "lastRemarks",
                                    },
                                  },
                                  [
                                    _c("el-input", {
                                      attrs: {
                                        type: "textarea",
                                        autosize: { minRows: 2, maxRows: 4 },
                                        maxlength: "1000",
                                        "show-word-limit": "",
                                        disabled: "",
                                        placeholder: "请输入内容",
                                      },
                                      model: {
                                        value: _vm.lastRemarks,
                                        callback: function ($$v) {
                                          _vm.lastRemarks = $$v
                                        },
                                        expression: "lastRemarks",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        )
                      : _vm._e(),
                    _c(
                      "el-row",
                      { attrs: { gutter: 20 } },
                      [
                        _c(
                          "el-col",
                          { attrs: { span: 24 } },
                          [
                            _c(
                              "el-form-item",
                              {
                                class:
                                  _vm.ttRmcProteinPurchaseId &&
                                  _vm.detailForm.status !== "DRAFT"
                                    ? "is-required"
                                    : "",
                                attrs: {
                                  label: "修改原因",
                                  prop: "remarks",
                                  rules: _vm.rules.remarks,
                                },
                              },
                              [
                                _c("el-input", {
                                  attrs: {
                                    disabled: _vm.isDisabled,
                                    type: "textarea",
                                    maxlength: "1000",
                                    "show-word-limit": "",
                                    autosize: { minRows: 2, maxRows: 4 },
                                    placeholder: "请输入内容",
                                  },
                                  model: {
                                    value: _vm.detailForm.remarks,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.detailForm, "remarks", $$v)
                                    },
                                    expression: "detailForm.remarks",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ]),
              _c("div", { staticClass: "within_box" }, [
                _c("div", { staticClass: "title_box" }, [
                  _c("p", { staticClass: "line" }),
                  _c("p", { staticClass: "title" }, [_vm._v("采购量维护")]),
                ]),
                _c(
                  "div",
                  { staticClass: "form_box" },
                  [
                    _c(
                      "el-row",
                      {
                        staticStyle: { "margin-bottom": "5px" },
                        attrs: {
                          type: "flex",
                          justify: "space-between",
                          align: "middle",
                        },
                      },
                      [
                        _c(
                          "el-col",
                          { attrs: { span: 13 } },
                          [
                            (_vm.ms_roles.indexOf(
                              "QSPI_RMC_CHICK_BUYER_SUPP"
                            ) !== -1 ||
                              _vm.ms_roles.indexOf(
                                "QSPI_RMC_PORK_BUYER_SUPP"
                              ) !== -1) &&
                            !_vm.isDisabled
                              ? _c(
                                  "el-button",
                                  {
                                    directives: [
                                      {
                                        name: "acl",
                                        rawName: "v-acl",
                                        value: _vm.RMC_PROT_PCQTY_ADD_ASL,
                                        expression: "RMC_PROT_PCQTY_ADD_ASL",
                                      },
                                    ],
                                    attrs: { size: "small", type: "primary" },
                                    on: { click: _vm.onAddAsl },
                                  },
                                  [_vm._v("新增ASL")]
                                )
                              : _vm._e(),
                            (_vm.ms_roles.indexOf(
                              "QSPI_RMC_CHICK_BUYER_SUPP"
                            ) !== -1 ||
                              _vm.ms_roles.indexOf(
                                "QSPI_RMC_PORK_BUYER_SUPP"
                              ) !== -1) &&
                            !_vm.isDisabled
                              ? _c(
                                  "el-button",
                                  {
                                    directives: [
                                      {
                                        name: "acl",
                                        rawName: "v-acl",
                                        value: _vm.RMC_PROT_PCQTY_DEL_ASL,
                                        expression: "RMC_PROT_PCQTY_DEL_ASL",
                                      },
                                    ],
                                    attrs: { size: "small", type: "danger" },
                                    on: { click: _vm.onDelAsl },
                                  },
                                  [_vm._v("删除ASL")]
                                )
                              : _vm._e(),
                            (_vm.ms_roles.indexOf(
                              "QSPI_RMC_CHICK_BUYER_SUPP"
                            ) !== -1 ||
                              _vm.ms_roles.indexOf(
                                "QSPI_RMC_PORK_BUYER_SUPP"
                              ) !== -1) &&
                            !_vm.isDisabled
                              ? _c(
                                  "el-button",
                                  {
                                    directives: [
                                      {
                                        name: "acl",
                                        rawName: "v-acl",
                                        value: _vm.RMC_PROT_PCQTY_PICK_SUPP,
                                        expression: "RMC_PROT_PCQTY_PICK_SUPP",
                                      },
                                    ],
                                    attrs: { size: "small", type: "primary" },
                                    on: { click: _vm.onMaintainSupplier },
                                  },
                                  [_vm._v("维护供应商")]
                                )
                              : _vm._e(),
                            (_vm.ms_roles.indexOf(
                              "QSPI_RMC_CHICK_BUYER_SUPP"
                            ) !== -1 ||
                              _vm.ms_roles.indexOf(
                                "QSPI_RMC_PORK_BUYER_SUPP"
                              ) !== -1) &&
                            !_vm.isDisabled
                              ? _c(
                                  "el-button",
                                  {
                                    directives: [
                                      {
                                        name: "acl",
                                        rawName: "v-acl",
                                        value: _vm.RMC_PROT_PCQTY_EXPORT,
                                        expression: "RMC_PROT_PCQTY_EXPORT",
                                      },
                                    ],
                                    attrs: { size: "small", type: "primary" },
                                    on: { click: _vm.onExport },
                                  },
                                  [_vm._v("导出")]
                                )
                              : _vm._e(),
                            (_vm.ms_roles.indexOf(
                              "QSPI_RMC_CHICK_BUYER_SUPP"
                            ) !== -1 ||
                              _vm.ms_roles.indexOf(
                                "QSPI_RMC_PORK_BUYER_SUPP"
                              ) !== -1) &&
                            !_vm.isDisabled
                              ? _c(
                                  "el-button",
                                  {
                                    directives: [
                                      {
                                        name: "acl",
                                        rawName: "v-acl",
                                        value: _vm.RMC_PROT_PCQTY_IMPORT,
                                        expression: "RMC_PROT_PCQTY_IMPORT",
                                      },
                                    ],
                                    attrs: { size: "small", type: "primary" },
                                    on: { click: _vm.onBatchUpload },
                                  },
                                  [_vm._v("导入")]
                                )
                              : _vm._e(),
                          ],
                          1
                        ),
                        _c("el-col", { attrs: { span: 11 } }, [
                          _c("span", [
                            _vm._v(
                              "提示:结算单位/Facility,如果是结算单位选择以后字体默认为蓝色,最多20家供应商伙伴"
                            ),
                          ]),
                        ]),
                      ],
                      1
                    ),
                    _c(
                      "el-table",
                      {
                        key: Math.random(),
                        ref: "plxTable",
                        attrs: {
                          data: _vm.filteredTableData,
                          "max-height": "500",
                          border: "",
                          "highlight-current-row": "",
                        },
                        on: { "selection-change": _vm.selectionChange },
                      },
                      [
                        _c("el-table-column", {
                          key: "base1",
                          attrs: { type: "selection", width: "55" },
                        }),
                        _c("el-table-column", {
                          key: "base2",
                          attrs: { type: "index", label: "序号", width: "50" },
                          scopedSlots: _vm._u([
                            {
                              key: "default",
                              fn: function (scope) {
                                return [
                                  _vm._v(
                                    " " + _vm._s((scope.$index + 1) * 10) + " "
                                  ),
                                ]
                              },
                            },
                          ]),
                        }),
                        _c("el-table-column", {
                          key: "base3",
                          attrs: {
                            label: "ASL",
                            prop: "aslName",
                            align: "center",
                            "show-overflow-tooltip": "",
                          },
                        }),
                        _vm.detailForm.category3Code == "10101"
                          ? _c("el-table-column", {
                              key: "base4",
                              attrs: {
                                label: "养殖模式",
                                prop: "",
                                align: "center",
                                "show-overflow-tooltip": "",
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "default",
                                    fn: function (scope) {
                                      return [
                                        _vm._v(
                                          " " +
                                            _vm._s(scope.row.breedingModeView) +
                                            " "
                                        ),
                                      ]
                                    },
                                  },
                                ],
                                null,
                                false,
                                188874023
                              ),
                            })
                          : _vm._e(),
                        _vm._l(_vm.columns, function (item, index) {
                          return [
                            _c(
                              "el-table-column",
                              {
                                key: index,
                                attrs: {
                                  label: item.supplierName,
                                  prop: item.purchaseQuantity,
                                  "min-width": "190",
                                  "show-overflow-tooltip": "",
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function (scope) {
                                        return [
                                          _c(
                                            "div",
                                            [
                                              _c("el-input", {
                                                attrs: {
                                                  disabled: _vm.isDisabled,
                                                },
                                                model: {
                                                  value:
                                                    scope.row.aslDetail[index]
                                                      .purchaseQuantity,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      scope.row.aslDetail[
                                                        index
                                                      ],
                                                      "purchaseQuantity",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "scope.row.aslDetail[index].purchaseQuantity",
                                                },
                                              }),
                                            ],
                                            1
                                          ),
                                        ]
                                      },
                                    },
                                  ],
                                  null,
                                  true
                                ),
                              },
                              [
                                _c("template", { slot: "header" }, [
                                  _c(
                                    "p",
                                    {
                                      class: item.type === 0 ? "blueClass" : "",
                                    },
                                    [_vm._v(_vm._s(item.supplierName))]
                                  ),
                                ]),
                              ],
                              2
                            ),
                          ]
                        }),
                      ],
                      2
                    ),
                  ],
                  1
                ),
              ]),
            ]
          ),
        ],
        1
      ),
      _vm.dialogAslVisible
        ? _c(
            "el-dialog",
            {
              attrs: {
                title: "ASL主数据",
                visible: _vm.dialogAslVisible,
                "modal-append-to-body": false,
                width: "85%",
              },
              on: {
                "update:visible": function ($event) {
                  _vm.dialogAslVisible = $event
                },
                close: _vm.onCloseAsl,
              },
            },
            [
              _c("asl-Dialog", {
                attrs: {
                  aslTableData: _vm.aslTableData,
                  id: _vm.ttRmcProteinPurchaseId,
                  rmcProtAslIdLists: _vm.rmcProtAslIdLists,
                },
                on: { onCloseAsl: _vm.onCloseAsl, setAsl: _vm.setAsl },
              }),
            ],
            1
          )
        : _vm._e(),
      _vm.dialogSupplierVisible
        ? _c(
            "el-dialog",
            {
              attrs: {
                title: "供应商主数据",
                visible: _vm.dialogSupplierVisible,
                "modal-append-to-body": false,
                width: "85%",
              },
              on: {
                "update:visible": function ($event) {
                  _vm.dialogSupplierVisible = $event
                },
                close: _vm.onCloseSupplier,
              },
            },
            [
              _c("supplier-Dialog", {
                attrs: { data: _vm.original_table },
                on: {
                  onCloseSupplier: _vm.onCloseSupplier,
                  setSupplier: _vm.setSupplier,
                  setFacility: _vm.setFacility,
                },
              }),
            ],
            1
          )
        : _vm._e(),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "批量导入",
            visible: _vm.dialogBatchUploadVisible,
            width: "40%",
            "close-on-click-modal": false,
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogBatchUploadVisible = $event
            },
            close: _vm.onCloseUpload,
          },
        },
        [
          _c(
            "el-row",
            { staticStyle: { "margin-bottom": "10px" } },
            [
              _c(
                "el-upload",
                {
                  ref: "batchUpload",
                  staticStyle: {
                    display: "inline-block",
                    "margin-right": "10px",
                  },
                  attrs: {
                    headers: _vm.header,
                    action: _vm.importDetailUrl,
                    data: {
                      ttRmcProteinPurchaseId: this.ttRmcProteinPurchaseId
                        ? this.ttRmcProteinPurchaseId
                        : " ",
                      month: this.detailForm.month
                        ? this.detailForm.month
                        : null,
                    },
                    "on-success": _vm.uploadSuccess,
                    "on-error": _vm.uploadError,
                    "before-upload": _vm.beforeUpload,
                    "on-change": _vm.handleChange,
                    "file-list": _vm.fileList,
                    "auto-upload": false,
                    "show-file-list": false,
                  },
                },
                [
                  _c(
                    "el-button",
                    { attrs: { size: "small", type: "primary" } },
                    [_vm._v("选取文件")]
                  ),
                ],
                1
              ),
              _c(
                "el-link",
                {
                  attrs: {
                    type: "button",
                    target: "_blank",
                    href:
                      _vm.detailForm.category3Code == "10101"
                        ? "static/template/qspi/poultry/Protein采购量维护.xlsx"
                        : "static/template/qspi/pork/Protein采购量维护.xlsx",
                    download: "Protein采购量维护.xlsx",
                  },
                },
                [
                  _c(
                    "el-button",
                    {
                      staticClass: "btn",
                      staticStyle: { height: "100%" },
                      attrs: { type: "primary", size: "small" },
                    },
                    [_vm._v("导入模板下载")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-form",
            { ref: "uploadForm", attrs: { model: _vm.uploadForm } },
            [
              _c(
                "el-form-item",
                [
                  _c("el-input", {
                    attrs: { readonly: "" },
                    model: {
                      value: _vm.uploadForm.fileName,
                      callback: function ($$v) {
                        _vm.$set(_vm.uploadForm, "fileName", $$v)
                      },
                      expression: "uploadForm.fileName",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c("el-row", [
            _c("h4", [_vm._v("说明:")]),
            _c("ul", [
              _c("li", [_vm._v("1.请点击模板下载,按照模板填写后再上传")]),
              _c("li", [_vm._v("2.模板中红色字段为必填项,请务必正确填写")]),
              _c("li", [_vm._v("3.仅支持上传Excel格式文件,且大小不能超过20M")]),
              _c("li", [
                _vm._v("4.为保证上传成功,请勿对模板中的单元格进行修改"),
              ]),
              _c("li", [
                _vm._v("5.一次仅支持一份文件上传,多份文件上传将会替换原文件"),
              ]),
            ]),
          ]),
          _c(
            "el-row",
            { attrs: { type: "flex", justify: "center" } },
            [
              _c(
                "el-button",
                {
                  staticClass: "btn",
                  attrs: { size: "mini", type: "primary" },
                  on: { click: _vm.onUpload },
                },
                [_vm._v("上传")]
              ),
              _c(
                "el-button",
                {
                  staticClass: "btn",
                  attrs: { size: "mini", type: "primary" },
                  on: { click: _vm.onClose1 },
                },
                [_vm._v("关闭")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }